import { useEffect, useState } from 'react'

// この JS 実行中に起動モーションを見せたか。
//
// 「起動直後か」を壁時計の窓で近似すると、 起動時の直列読み込み (認証 →
// use_legacy_ui 設定 → 薬歴リスト。 この間サイドバーは未マウント) が窓を食い潰し、
// 初回表示なのに再生されない。 「まだ一度も見せていないか」で判定すれば、
// 読み込みに何秒かかっても初回表示では必ず動き、 折りたたみ → 再展開
// (unmount → mount) では動かない。
let bootRevealShown = false

/**
 * 起動モーション (ADR-0026) を「初回表示だけ」にする判定。 true なら見せてよい。
 *
 * 判定は **マウント時に 1 度だけ固定する**。 描画のたびにフラグを読むと、 自分の
 * effect が立てたフラグを次の描画で拾い、 アニメーション途中に animation が消える。
 * 消費の記録を初期化関数でなく effect で行うのは StrictMode 対応 —— 初期化関数は
 * 二重に呼ばれるため、 そこで記録すると 2 回目が false を拾い開発時に一度も見えない。
 */
export const useBootReveal = () => {
  const [isBoot] = useState(() => !bootRevealShown)

  useEffect(() => {
    bootRevealShown = true
  }, [])

  return isBoot
}
